<template>
    <div>
      <v-card class="card--flex-toolbar" flat>
          <v-tabs color="grey lighten-3" v-model="current_tab" dark slider-color="grey darken-4">
              <v-tab ripple v-for="tab in tabs" :key="tab.href" :to="{name: tab.route_name}" class="grey--text text--darken-4 caption">{{tab.text}}</v-tab>
          </v-tabs>
      </v-card>
      <v-card v-if="isLoading" height="50vh">
        <h1></h1>
      </v-card >
      <router-view></router-view>
    </div>
  </template>
  <script>
  import i18n from "@/i18n";

  export default {
    name: "TranslationsRoot",
    data() {
      return {
        current_tab: 'overview',
        isLoading: false,
        tabs: [
          {
            text: i18n.t('assets_manager.list.sub_title.tags'),
            route_name: 'translation.tags'
          },
        ],
      };
    },

  };
  </script>
